import dynamic from 'next/dynamic';

/**
 * The player UI is only ever useful once there's a track to play, and it drags
 * in the drawer, waveform, controls and playback hooks (~24 KB gz). Keeping it
 * out of the shared `_app` chunk means pages with no audio never pay for it
 * (DEV-6487).
 *
 * `ssr: false` matches the old behaviour: the queue is client-only state, so
 * the player always rendered `null` on the server anyway.
 *
 * Nothing here changes atom lifecycle — every atom the player reads is defined
 * in `./atoms`, which stays in the main bundle and is created by module
 * evaluation, not by the component mounting.
 */
const importAudioPlayer = () => import('./AudioPlayer');

export const LazyAudioPlayer = dynamic(importAudioPlayer, { ssr: false });

/**
 * Warm the player chunk ahead of the click. Webpack dedupes the request, so
 * calling this repeatedly is free and the later `dynamic` mount resolves from
 * cache instead of the network.
 */
export const preloadAudioPlayer = (): void => {
  void importAudioPlayer();
};
